import ProjectDetailComponent from "../components/ProjectDetailComponent";
import AddOnComponent from "../components/AddOnComponent";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

const ProjectDetailPage = () => {
  const location = useLocation();
  const [projects, setProjects] = useState([]);
  const [project, setProject] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const { data } = await axios.get(process.env.REACT_APP_PROJECTS_URL);
        setProjects(data);
        const currentProject = data.find(
          (p) => p.id === parseInt(location.pathname.split("/")[2])
        );
        setProject(currentProject);
      } catch (err) {
        console.error("Failed to fetch projects:", err);
      }
    };
    fetchProjects();
  }, [location.pathname]);

  if (!project) return <div>Loading...</div>;

  return (
    <div className="bg-primary">
      <ProjectDetailComponent project={project} />
      <AddOnComponent />
    </div>
  );
};

export default ProjectDetailPage;